import React from 'react';
import PropTypes from 'prop-types';

import WithOrganizationActivityMetaTags from '../DataHOCs/WithOrganizationActivityMetaTags';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import OrgActMetaTagCategoryEditor from './OrgActMetaTags/OrgActMetaTagCategoryEditor';
import OrgActMetaTypesEditor from './OrgActMetaTags/OrgActMetaTypesEditor';
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    orgId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    orgActMetaTags: PropTypes.object.isRequired,
    actMetaTagCategories: PropTypes.object.isRequired,
    orgActMetaTypes: PropTypes.array.isRequired,
};

const defaultProps = {};

function OrgActMetaTagsView(props) {
    return (
        <div>
            <div className="channelHeadingFlex">
                <div className="channelHeadingFlex__heading">
                    { !!props.backHandler &&
                            <button
                            className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                            onClick={props.backHandler}
                            title="Back">
                                <AccessibleIcon
                                label="Back">
                                    <span className="fa fa-chevron-left" aria-hidden={true}/>
                                </AccessibleIcon>
                            </button>
                    }
                    <h2 className="heading-lg">{props.heading}</h2>
                </div>
            </div>

            {Object.keys(props.actMetaTagCategories).map((categoryId) =>
                <OrgActMetaTagCategoryEditor
                    key={categoryId}
                    className="tile-dash-floating margin-bottom-xl"
                    orgId={props.orgId}
                    categoryId={categoryId}
                    category={props.actMetaTagCategories[categoryId]}
                    tags={props.orgActMetaTags[categoryId]}
                />
            )}
            <OrgActMetaTypesEditor
                className="tile-dash-floating margin-bottom-xl"
                orgId={props.orgId}
                types={props.orgActMetaTypes}
            />
        </div>
    );
}

OrgActMetaTagsView.propTypes = propTypes;
OrgActMetaTagsView.defaultProps = defaultProps;

export default WithOrganizationActivityMetaTags(WithChannelActivities(OrgActMetaTagsView));